import styled from "styled-components";
import media from "constants/media";

export const Error = styled.div`
    margin: 30px 0 60px;
    padding: 20px 25px;

    color: var(--color-red);

    background-color: rgba(226, 73, 73, 0.2);
`;

export const Text = styled.p`
    margin-bottom: 24px;

    font-size: 14px;
    line-height: 20px;
    text-align: left;

    :last-of-type {
        margin-bottom: 0;
    }

    ${media.mdUp`
        margin-bottom: 28px;

        font-size: 15px;
        line-height: 25px;
    `}
`;
